import type { Path } from '@remix-run/react';

/**
 * Builds a pagination URL based on the current path and the desired page number.
 *
 * @param {Path | null} currentPath - The current path object which includes pathname and search parameters.
 * @param {number} page - The page number to navigate to.
 * @returns {string} The constructed URL for the pagination.
 */
export const buildPaginationUrl = (
    currentPath: Path | null,
    page: number
): string => {
    if (currentPath === null) {
        return '#';
    }

    const searchParams = new URLSearchParams(currentPath.search);

    if (page > 1) {
        searchParams.set('page', page.toString());
    } else {
        searchParams.delete('page');
    }

    const baseUrl = currentPath.pathname;
    const queryString = searchParams.toString();

    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
